import { useCustomRouter, useReservation } from '@/root/shared-hooks'
import { getTermsByLocale, sanitizeHtml } from '@/root/shared-helpers'
import { FC } from 'react'

export const TicketTerms: FC = () => {
  const { reservation } = useReservation()
  const { locale } = useCustomRouter()

  const termsClassNames = 'md:flex-1 [&>p>a]:underline [&>ul]:list-disc [&>ul]:pl-3 [&>p:has(+ul):not(ul+p)]:font-bold'

  if (!reservation) {
    return null
  }

  const terms = getTermsByLocale(reservation.terms, locale)

  if (!terms) return null

  return (
    <div className="mb-15 flex flex-col gap-5 text-base md:flex-row md:gap-10">
      <div className={termsClassNames} dangerouslySetInnerHTML={{ __html: sanitizeHtml(terms.ticketTerms) }} />
      <div
        className={termsClassNames}
        dangerouslySetInnerHTML={{
          __html: sanitizeHtml(terms.additionalTicketTerms),
        }}
      />
    </div>
  )
}

export default TicketTerms
